/* eslint-disable functional/no-expression-statement */
import React from "react";

import { Timeline } from "~/Timeline";

export type BrushEvent =
  | "BrushLeft"
  | "BrushRight"
  | "BrushLeftMax"
  | "BrushRightMax"
  | "BrushReset"
  | "BrushIn"
  | "BrushOut";

export type EventCallback = (e: Event) => void;

export const eventBus = (container: React.RefObject<HTMLDivElement>) => ({
  on(event: BrushEvent, callback: EventCallback) {
    if (!container || !container?.current) return;
    container.current.addEventListener(event, (e) => callback(e));
  },
  dispatch(event: BrushEvent) {
    if (!container || !container?.current) return;
    container.current.dispatchEvent(new CustomEvent(event));
  },
  remove(event: BrushEvent, callback: EventCallback) {
    if (!container || !container?.current) return;
    container.current.removeEventListener(event, callback);
  },
});

export const useFromRef = (
  container: React.RefObject<HTMLDivElement>
): Timeline.Scroll.Events => {
  return {
    onLeft: () => {
      eventBus(container).dispatch("BrushLeft");
    },
    onLeftMax: () => {
      eventBus(container).dispatch("BrushLeftMax");
    },
    onRight: () => {
      eventBus(container).dispatch("BrushRight");
    },
    onRightMax: () => {
      eventBus(container).dispatch("BrushRightMax");
    },
    onZoomIn: () => {
      eventBus(container).dispatch("BrushIn");
    },
    onZoomOut: () => {
      eventBus(container).dispatch("BrushOut");
    },
    onZoomReset: () => {
      eventBus(container).dispatch("BrushReset");
    },
  };
};

type UnmountCallback = () => void;

export const bind = (
  container: React.RefObject<HTMLDivElement>,
  handlers: Timeline.Scroll.Events
): UnmountCallback => {
  if (container && container?.current) {
    eventBus(container).on("BrushLeft", handlers.onLeft);
    eventBus(container).on("BrushLeftMax", handlers.onLeftMax);
    eventBus(container).on("BrushRight", handlers.onRight);
    eventBus(container).on("BrushRightMax", handlers.onRightMax);
    eventBus(container).on("BrushReset", handlers.onZoomReset);
    eventBus(container).on("BrushIn", handlers.onZoomIn);
    eventBus(container).on("BrushOut", handlers.onZoomOut);
  }
  return () => {
    if (container && container?.current) {
      eventBus(container).remove("BrushLeft", handlers.onLeft);
      eventBus(container).remove("BrushLeftMax", handlers.onLeftMax);
      eventBus(container).remove("BrushRight", handlers.onRight);
      eventBus(container).remove("BrushRightMax", handlers.onRightMax);
      eventBus(container).remove("BrushReset", handlers.onZoomReset);
      eventBus(container).remove("BrushIn", handlers.onZoomIn);
      eventBus(container).remove("BrushOut", handlers.onZoomOut);
    }
  };
};
